<template>
  <div class="modals" :class="{ 'modal-show': modalshow }" v-show="showmodals">
    <div style="height:40px">
      <img
        alt="图形验证码"
        style="width:120px;height:40px;"
        @click="editCaptcha"
        :src="'/api/common/getImgCode' + captcha"
      />
      <span class="reload" @click="editCaptcha"></span>
    </div>
    <div style="margin-top:5px">
      <input
        type="text"
        v-model="imgCode"
        placeholder="输入验证码"
        @keyup.enter="confirm"
      />
      <button @click.prevent="confirm">
        <span></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '发送验证码',
      imgCode: '',
      captcha: '',
      showmodals: false,
      modalshow: false,
      refreshTimeout: '',
    }
  },
  methods: {
    show() {
      this.imgCode = ''
      this.editCaptcha()
      // this.$refs.box.clearWrong()
      this.showmodals = true
      setTimeout(() => {
        this.modalshow = true
      }, 100)
    },
    // setWrong(msg) {
    //     //   this.$refs.box.setWrong(msg);
    // },
    hide() {
      this.modalshow = false
      setTimeout(() => {
        this.showmodals = false
      }, 500)
    },
    // 刷新验证码
    editCaptcha() {
      this.captcha = '?' + new Date().getTime()
    },
    async confirm() {
      this.$emit('confirm', this.imgCode)
      this.hide()
    },
    refresh() {
      this.refreshTimeout = setTimeout(() => {
        this.editCaptcha()
        this.refresh()
      }, 300000)
    },
  },
  watch: {
    showmodals() {
      if (this.showmodals == true) {
        this.refresh()
      } else {
        clearTimeout(this.refreshTimeout)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modals {
  position: absolute;
  min-width: 120px;
  min-height: 75px;
  background-color: rgb(247, 247, 247);
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: all 0.5s;
  input {
    float: left;
    width: 80px;
    height: 30px;
    padding-left: 10px;
  }
  button {
    float: left;
    width: 30px;
    height: 30px;
    background-color: rgb(26, 123, 208);
    span {
      display: block;
      width: 30px;
      height: 30px;
      background: url(../../assets/img/icon/u1336.png) no-repeat 10px 8px;
    }
  }
  .reload {
    position: absolute;
    top: 12px;
    right: 12px;
    display: block;
    width: 12px;
    height: 12px;
    background: url(../../assets/img/icon/u1332.png) no-repeat;
    cursor: pointer;
  }
}
.modal-show {
  opacity: 1;
  transition: all 0.5s;
}
</style>
